import { httpGet } from "../../../../../modules/Backend";
import AdobeComboBox from "../../../../AdobeAriaLib/AdobeComboBox";
import { IOption } from "../../../../AdobeAriaLib/AdobeSelect";
import { useEffect, useState } from "react";

interface IFormSelectWrapper {
    value: string
    label: string
    entityName: string
    required: boolean
    onChange: Function
    disabled?: boolean
    parentId?: string
}

export default function FormSelectWrapper({ value, disabled, label, entityName, required, onChange, parentId }: IFormSelectWrapper) {
    const [options, setOptions] = useState<IOption[]>()

    function handleChange(val : string){
        onChange(val)
    }

    function isDisabled() {
        return disabled ?? false
    }

    async function getData() {
        try {
            let url = `api/${entityName}/filterData`;
            if (parentId) {
                url += `?parentId=${parentId}`;
            }
            const result = await httpGet(url)
            if (result.data) {
                // Handle various response key formats
                // ASP.NET Core serializes LocationTypes as locationTypes (camelCase)
                const locationTypesKey = entityName === 'locations' ? 'locationTypes' : null;
                const dataKey = result.data[entityName] ? entityName : 
                               result.data[`${entityName}s`] ? `${entityName}s` :
                               (locationTypesKey && result.data[locationTypesKey]) ? locationTypesKey :
                               Object.keys(result.data)[0];
                setOptions(result.data[dataKey])
            }
        }
        catch (err) {
        }
    }

    useEffect(() => {
        getData()
    }, [parentId])

    return (
        <div>
            <AdobeComboBox
                value={value}
                label={label}
                labelVisible={true}
                options={options}
                required={required}
                onChangeSelect={handleChange}
                disabled={isDisabled()}
                selectionMode="single" />
        </div>
    )
}